import { lazyLoad } from 'utils/loadable';

export const TermsPage = lazyLoad(
  () => import('./index'),
  module => module.TermsPage,
);
